<template>
    <modal-content @close="$emit('close')">
        <form @submit.prevent="onSubmit">
            <div class="form__row">
                <form-input label="Označení jednotky" :v="$v" name="designation" v-model="$v.designation.$model"/>
            </div>
            <br>
            <p>Z jaké jednotky bude kopie vytvořena?</p>
            <unit-autocomplete :v="$v" name="unitId" v-model="$v.unitId.$model"/>
            <br>
            <div class="form__row z1">
                <custom-button type="submit" outline>Zkopírovat</custom-button>
            </div>
        </form>
    </modal-content>
</template>

<script>
import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import CreateUnitForm from '@/modules/ProjectModule/modules/UnitModule/components/Unit/CreateUnitForm';
import UnitAutocomplete from '@/components/Autocomplete/UnitAutocomplete';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:        'CopyUnitDialog',
    components:  {CustomButton, ModalContent, FormInput, UnitAutocomplete, CreateUnitForm},
    data() {
        return {
            unitId:      null,
            designation: null,
        }
    },
    validations: {
        unitId:      {
            required,
        },
        designation: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(20),
        },
    },
    methods:     {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const {designation, unitId} = this;
                this.$store.dispatch('projects/project/units/copyUnit', {designation, id: unitId})
                    .then(({id}) => {
                        this.$router.push({name: 'project-unit-detail', params: {unitId: id}})
                        this.$emit('close');
                    });
            }
        }
    }
}
</script>
